import { FC } from "react";
import { observer } from "mobx-react-lite";
import { SessionsListPageListEmpty } from "./SessionsListPageListEmpty";
import { MdsVirtualizedItemList } from "@/design-system/components/item-list";
import { useTabPageStore } from "@/hooks/useTabPageStore";

interface SessionsListPageListProps {}

export const SessionsListPageList: FC<SessionsListPageListProps> = observer(() => {
  const page = useTabPageStore("sessionsListPage");

  if (page.isEmpty) {
    return <SessionsListPageListEmpty />;
  }

  return <MdsVirtualizedItemList rows={page.itemRows} loading={false} />;
});
